import Dropzone from 'react-dropzone';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import Txt from '../../../../inputs/textInput.js';
import { forceValidation } from '../../../../../businessLogic/validation.js';
import AvatarEditor from 'react-avatar-editor';
import PreviewProfileImageModal from '../../preview-profile-image/content.js';
import { resetImageAsync, resetImageToDefault, setProfileImageDropped } from '../../../../../actions/user.js';
import { Icon } from 'semantic-ui-react';
import Hammer from 'react-hammerjs';
import EXIF from 'exif-js';
import { event } from 'jquery';

const UserProfileAccountPasswordSection = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const avatarRefs = useRef(ref);
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const [profileImageDroppedScale, setProfileImageDroppedScale] = useState(profileDefaultValue);
  const [profileImageEdited, setProfileImageEdited] = useState('');
  const [rotate, setRotate] = useState(props.rotate || 0);

  const fetchingUserProfile = useSelector((state) => state.usersReducer.fetchingUserProfile);
  const isProfileImageEditable = useSelector((state) => state.usersReducer.isProfileImageEditable);
  const profileImageDropped = useSelector((state) => state.usersReducer.profileImageDropped);

  let profileDefaultValue = 1.0;
  let minimumProfileImageDroppedScale = 1.0;
  let maximumProfileImageDroppedScale = 3.0;

  const onDrop = (files) => {
    if (files.length > 0) {
      //added code so we dont throw exceptions when no images were dropped
      EXIF.getData(files[0], function () {
        var orientation = EXIF.getTag(this, 'Orientation');
        let rotatePic = 0;
        switch (orientation) {
          case 8:
            rotatePic = 270;
            break;
          case 6:
            rotatePic = 90;
            break;
          case 3:
            rotatePic = 180;
            break;
          default:
            rotatePic = 0;
        }
        props.setRotation(rotatePic);
      });
      dispatch(setProfileImageDropped(files[0].preview));
      forceValidation(null, null, 'profileSaveChanges');
      $('input:file').val(''); //v.important so we can select the same image again
    }
  };

  useEffect(() => {
    window.$('.user-profile canvas').click((event) => {
      event.stopPropagation();
    });

    if (props.profileImageDroppedScaleParent) {
      setProfileImageDroppedScale(props.profileImageDroppedScaleParent || profileDefaultValue);
    }
  }, [props.profileImageDroppedScaleParent]);

  const handleZoom = (evt) => {
    evt.preventDefault();
    if (evt.deltaY > 0) {
      //this means scroll down
      if (profileImageDroppedScale - 0.1 >= minimumProfileImageDroppedScale)
        props.setProfileImageDroppedScaleMethod(profileImageDroppedScale - 0.1);
    } else {
      //this means scroll up
      if (profileImageDroppedScale + 0.1 < maximumProfileImageDroppedScale)
        props.setProfileImageDroppedScaleMethod(profileImageDroppedScale + 0.1);
    }
  };

  useImperativeHandle(ref, () => ({
    getBase64: () => {
      return avatarRefs.current.getImageScaledToCanvas().toDataURL();
    },
  }));

  const getBase64 = () => {
    return avatarRefs.current.getImageScaledToCanvas().toDataURL();
  };

  const handleUpload = () => {
    window.$('.user-profile .drop-zone input')[0].click();
    // this is only the event when u click 'upload', it does not mean u choosed file.
  };

  const resetImage = () => {
    dispatch(setProfileImageDropped(userProfile.userImageUrl));
    console.info('before dispatch reset');
    dispatch(resetImageAsync());
    console.info('after dispatch reset');
  };

  const resetToDefaultImage = () => {
    dispatch(resetImageToDefault());
  };

  const openPreview = (image) => {
    let croppedImage = getBase64();
    setProfileImageEdited(croppedImage);
    window.$('.ui.modal.preview-image').modal({ closable: true }).modal('show');
  };
  const onPinchOut = (e) => {
    console.log('onPinchOut;', e);
    if (profileImageDroppedScale < maximumProfileImageDroppedScale) {
      props.setProfileImageDroppedScaleMethod(profileImageDroppedScale + 0.1);
    }
  };
  const onPinchIn = (e) => {
    console.log('onPinchIn;', e);
    if (profileImageDroppedScale > minimumProfileImageDroppedScale) {
      props.setProfileImageDroppedScaleMethod(profileImageDroppedScale - 0.1);
    }
  };

  const userMenuOptionTrigger = <Icon name="camera" className="fl pdls" />;
  const itemClass = 'no-sub-menu';
  const supaDropdownUserMenuClassName = 'ui dropdown  item fr imageUpload';
  let userMenuOptions = [];
  let isResetImage = false;
  if (userProfile && (userProfile.userImageUrl || isProfileImageEditable)) {
    isResetImage = true;
  }
  userMenuOptions = [
    {
      text: APP.LANGUAGE.UserProfile.Upload,
      className: itemClass,
      onClick: handleUpload,
    },
    {
      text: APP.LANGUAGE.UserProfile.Reset,
      className: itemClass,
      onClick: () => resetToDefaultImage(),
      className: isResetImage ? 'item' : 'item disabled',
    },
  ];

  let resetClasses = ' ui button color-bad-things color-white  ';
  let previewClasses = ' ui button color-button color-button-hover color-white ';
  let uploadClasses = ' ui button color-button color-button-hover color-white  ';
  let modals = <PreviewProfileImageModal imageToPreview={profileImageEdited} />;

  let options = {
    recognizers: {
      pinch: { enable: true },
    },
  };
  // console.log('this props rotate', props.rotate);
  let imageDisplay = isProfileImageEditable ? (
    <Hammer options={options} onPinchIn={onPinchIn} onPinchOut={onPinchOut}>
      <div>
        <AvatarEditor
          image={profileImageDropped}
          width={640}
          height={640}
          border={20}
          ref={avatarRefs}
          onDrop={onDrop}
          onSave={getBase64}
          onChange
          onMouseMove={() => {
            event.stopPropagation(event);
            event.preventDefault();
          }}
          onMouseUp={() => {
            event.stopPropagation();
            event.preventDefault();
          }}
          color={[255, 255, 255, 0.7]} // RGBA
          scale={profileImageDroppedScale}
          rotate={rotate}
        />
      </div>
    </Hammer>
  ) : (
    <img src={userProfile.userImageUrl ? userProfile.userImageUrl : userProfile.defaultImageUrl} />
  );

  return (
    <div>
      <Dropzone disableClick={true} onDrop={onDrop} className="drop-zone pointer pdtnull" accept="image/*">
        <div className="canvas-holder mrbm" onWheel={handleZoom}>
          <Txt
            semanticui
            dropdown
            MenuClassName="imageUploadDropDown"
            trigger={userMenuOptionTrigger}
            className={supaDropdownUserMenuClassName}
            options={userMenuOptions}
          />
          {imageDisplay}
          <div className="placeholder-label color-placeholder">{APP.LANGUAGE.UserProfile.ProfileImgCaption1}</div>
          <div className="placeholder-label color-placeholder">{APP.LANGUAGE.UserProfile.ProfileImgCaption2}</div>
        </div>
      </Dropzone>
    </div>
  );
});

UserProfileAccountPasswordSection.displayName = 'UserProfileAccountPasswordSection';

export default UserProfileAccountPasswordSection;
